export default __webpack_public_path__ + "static/media/morning-waterfalls.2d70c76e.gif";